module.exports = __webpack_public_path__ + "img/hr-rock-big-10.db4562cb.png";